import React from 'react';
import Styled from './Paragraph.style';

export default function Paragraph({ children }) {
	return (
		<Styled.Paragraph>
			{children}
		</Styled.Paragraph>
	)
}